export default function RatingActiveStar({ value }) {
  let rating = Number(value);

  // Handle invalid values
  if (isNaN(rating)) rating = 0;

  // Round to nearest integer
  rating = Math.round(rating);

  // Clamp between 0 and 5
  rating = Math.max(0, Math.min(5, rating));

  return (
    <div className ="star-sec">
      {[...Array(5)].map((_, i) => (
        <i
          key={i}
          className ={`fa-solid fa-star ${i < rating ? "active" : "disabled"}`}
        ></i>
      ))}
    </div>
  );
}
